import React from 'react';

export default function SectionHead({ eyebrow, title, body }) {
  return (
    <div className="max-w-3xl">
      <div className="flex items-center gap-3 mb-3 sm:mb-4">
        <span className="h-px w-8 sm:w-10 bg-cyan-400" />
        <span className="font-tech text-cyan-300 text-[10px] sm:text-[11px] uppercase">{eyebrow}</span>
      </div>
      <h2 className="font-display text-white text-3xl sm:text-4xl md:text-5xl font-bold uppercase leading-[1.05] sm:leading-[1.02] tracking-tight">
        {title}
      </h2>
      {body && <p className="mt-4 sm:mt-5 text-zinc-400 text-sm sm:text-base md:text-lg max-w-2xl">{body}</p>}
    </div>
  );
}
